import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LoadingSpinner from '@/components/common/LoadingSpinner';
const PageLoadingState = () => (_jsxs("div", { className: "home-shell__loading", children: [_jsx(LoadingSpinner, { size: "lg" }), _jsx("div", { className: "home-shell__loading-copy", children: "Preparing the React map workspace\u2026" })] }));
export default PageLoadingState;
